import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: column;
  min-width: 400px;

  header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 8px;

    span {
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      width: 100%;
    }

    img {
      cursor: pointer;
    }
  }

  .content {
    img {
      width: 100%;
    }
  }

  .reservation-details {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    gap: 8px;
    margin-bottom: 20px;

    .datetime-details {
      font-weight: bold;
      font-size: 18px;
    }

    .seats-details {
      font-size: 14px;
    }

    .event-end-notice {
      align-self: center;
    }
  }
    
  @media screen and (max-width: 768px) {
    min-width: 200px;
  }
`